import React from "react";
import { useTranslation } from "react-i18next";

// 서비스 특장점 카드 데이터
export default function Services() {
  const { t } = useTranslation();
  const serviceCards = [
    {
      icon: "fa-calendar-alt",
      label: t("main.services.cards.1.label"),
      desc: t("main.services.cards.1.desc"),
    },
    {
      icon: "fa-tags",
      label: t("main.services.cards.2.label"),
      desc: t("main.services.cards.2.desc"),
    },
    {
      icon: "fa-coins",
      label: t("main.services.cards.3.label"),
      desc: t("main.services.cards.3.desc"),
    },
    {
      icon: "fa-tasks",
      label: t("main.services.cards.4.label"),
      desc: t("main.services.cards.4.desc"),
    },
  ];
  return (
    <div className="container py-5">
      <div className="row justify-content-center mb-4">
        <div className="col-12 text-center mb-3">
          <div className="h4 font-weight-bold">{t("main.services.title")}</div>
          <div className="text-secondary">{t("main.services.description")}</div>
        </div>
        {serviceCards.map((card, idx) => (
          <div key={idx} className="col-12 col-md-6 mb-4">
            <div className="service-feature-card shadow-sm rounded d-flex flex-row align-items-center p-4 h-100 bg-light">
              <i className={`fas ${card.icon} fa-2x mr-3 text-info`} />
              <div>
                <div className="font-weight-bold mb-1" style={{ fontSize: 17 }}>
                  {card.label}
                </div>
                <div className="text-secondary" style={{ fontSize: 15 }}>
                  {card.desc}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
